export enum PaymentTypeEnum {
  Cash = 1,
  FuelCard = 2,
  BusinessCard = 3,
  PrivateEmployeeCard = 4,
  TransferCompanyAccount = 5,
  TransferEmployeeAccount = 6
}